import React from 'react';
export const Satellite = () => (
  <svg width="124px" height="87px" viewBox="0 0 124 87" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1329.000000, -1707.000000)">
        <g transform="translate(1329.000000, 1707.000000)">
          <path
            d="M32.3096,45.8647 C32.3096,46.7947 31.5566,47.5477 30.6276,47.5477 C29.6986,47.5477 28.9456,46.7947 28.9456,45.8647 C28.9456,44.9357 29.6986,44.1827 30.6276,44.1827 C31.5566,44.1827 32.3096,44.9357 32.3096,45.8647"
            fill="#FFFFFF"
          />
          <path
            d="M32.3096,45.8647 C32.3096,46.7947 31.5566,47.5477 30.6276,47.5477 C29.6986,47.5477 28.9456,46.7947 28.9456,45.8647 C28.9456,44.9357 29.6986,44.1827 30.6276,44.1827 C31.5566,44.1827 32.3096,44.9357 32.3096,45.8647 Z"
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M117.1143,44.183 C117.1143,45.112 116.3613,45.865 115.4323,45.865 C114.5033,45.865 113.7503,45.112 113.7503,44.183 C113.7503,43.254 114.5033,42.501 115.4323,42.501 C116.3613,42.501 117.1143,43.254 117.1143,44.183"
            fill="#FFFFFF"
          />
          <path
            d="M117.364,44.682 C117.364,45.611 116.611,46.364 115.682,46.364 C114.753,46.364 114,45.611 114,44.682 C114,43.753 114.753,43 115.682,43 C116.611,43 117.364,43.753 117.364,44.682 Z"
            stroke="#DCE4E7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M58.5703,0.7524 L58.5703,2.7524"
            stroke="#FE5E48"
            strokeLinecap="round"
          />
          <path
            d="M58.5703,6.7524 L58.5703,8.7524"
            stroke="#FE5E48"
            strokeLinecap="round"
          />
          <path
            d="M62.5703,4.7524 L60.5703,4.7524"
            stroke="#FE5E48"
            strokeLinecap="round"
          />
          <path
            d="M56.5703,4.7524 L54.5703,4.7524"
            stroke="#FE5E48"
            strokeLinecap="round"
          />
          <path
            d="M119.4321,56.7436 L119.4321,58.7436"
            stroke="#0B9CE5"
            strokeLinecap="round"
          />
          <path
            d="M119.4321,62.7436 L119.4321,64.7436"
            stroke="#0B9CE5"
            strokeLinecap="round"
          />
          <path
            d="M123.4321,60.7436 L121.4321,60.7436"
            stroke="#0B9CE5"
            strokeLinecap="round"
          />
          <path
            d="M117.4321,60.7436 L115.4321,60.7436"
            stroke="#0B9CE5"
            strokeLinecap="round"
          />
          <g transform="translate(59.000000, 26.710000)">
            <polyline
              fill="#FFFFFF"
              points="5.9307 2.3031 6.9517 0.2091 19.9147 6.5321 13.2247 20.2451 0.2627 13.9211 4.0597 6.1381"
            />
            <polyline
              stroke="#7350A0"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="5.9307 2.3031 6.9517 0.2091 19.9147 6.5321 13.2247 20.2451 0.2627 13.9211 4.0597 6.1381"
            />
          </g>
          <g transform="translate(61.000000, 50.710000)">
            <path d="M0.1533,2.4926 L1.2563,0.2326" fill="#FFFFFF" />
            <path
              d="M0.1533,2.4926 L1.2563,0.2326"
              stroke="#ED0722"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M68.8843,53.8031 L62.5923,50.7351 L55.9223,47.4801 C57.6683,43.9011 61.9853,42.4141 65.5653,44.1601 C69.1443,45.9071 70.6303,50.2241 68.8843,53.8031"
            fill="#FFFFFF"
          />
          <path
            d="M68.8843,53.8031 L62.5923,50.7351 L55.9223,47.4801 C57.6683,43.9011 61.9853,42.4141 65.5653,44.1601 C69.1443,45.9071 70.6303,50.2241 68.8843,53.8031 Z"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            fill="#FFFFFF"
            points="57.3262 35.9154 35.5502 25.2924 39.8292 16.5194 61.6062 27.1434"
          />
          <polygon
            stroke="#AA81F7"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="57.3262 35.9154 35.5502 25.2924 39.8292 16.5194 61.6062 27.1434"
          />
          <path
            d="M37.6899,20.9057 L59.4659,31.5297"
            stroke="#AA81F7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M46.978,20.0072 L42.698,28.7792"
            stroke="#AA81F7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M54.4561,23.6557 L50.1761,32.4277"
            stroke="#AA81F7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            fill="#FFFFFF"
            points="99.2808 56.2758 77.5048 45.6528 81.7838 36.8798 103.5608 47.5038"
          />
          <polygon
            stroke="#AA81F7"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="99.2808 56.2758 77.5048 45.6528 81.7838 36.8798 103.5608 47.5038"
          />
          <path
            d="M79.6445,41.266 L101.4205,51.89"
            stroke="#AA81F7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M88.9326,40.3676 L84.6536,49.1396"
            stroke="#AA81F7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M96.4106,44.0151 L92.1306,52.7871"
            stroke="#AA81F7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M32.3096,68.1713 C39.7186,66.4173 47.4476,65.4893 55.3936,65.4893 C77.9306,65.4893 98.7226,72.9563 115.4326,85.5523"
            stroke="#5DC1E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M0.8145,81.7143 C7.9935,77.0193 15.8145,73.2233 24.1165,70.4863"
            stroke="#5DC1E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            fill="#F3F4F6"
            points="73.7354 32.2865 68.4904 42.9545 71.4924 44.4145 76.5114 33.7255"
          />
          <path
            d="M67.1172,47.4789 L65.4562,50.6389 L67.9462,51.7529 C67.9462,51.7529 68.5072,48.7419 67.1172,47.4789"
            fill="#F3F4F6"
          />
          <path
            d="M97.4756,6.4145 C98.6956,5.3325 100.3006,4.6765 102.0586,4.6765 C105.8756,4.6765 108.9696,7.7695 108.9696,11.5865 C108.9696,15.4025 105.8756,18.4965 102.0586,18.4965 C98.2426,18.4965 95.1486,15.4025 95.1486,11.5865 C95.1486,10.6325 95.3426,9.7235 95.6916,8.8955"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <path
            d="M106.5518,8.6606 C106.5518,9.2446 106.0778,9.7186 105.4938,9.7186 C104.9098,9.7186 104.4358,9.2446 104.4358,8.6606 C104.4358,8.0756 104.9098,7.6016 105.4938,7.6016 C106.0778,7.6016 106.5518,8.0756 106.5518,8.6606"
            fill="#F3F4F6"
          />
          <path
            d="M107.3613,11.0307 C107.3613,11.3677 107.0883,11.6407 106.7513,11.6407 C106.4143,11.6407 106.1413,11.3677 106.1413,11.0307 C106.1413,10.6937 106.4143,10.4217 106.7513,10.4217 C107.0883,10.4217 107.3613,10.6937 107.3613,11.0307"
            fill="#F3F4F6"
          />
          <path
            d="M78.9146,70.4897 C77.9046,72.2687 85.6096,75.6157 84.7186,77.6927 C83.8266,79.7697 70.7416,80.1387 69.6156,82.8447 C68.4906,85.5527 74.0696,85.5527 74.0696,85.5527 L108.9696,85.5527 C102.0596,77.0457 78.9146,70.4897 78.9146,70.4897"
            fill="#F3F4F6"
          />
          <path
            d="M5.4717,82.8451 C5.4717,82.8451 11.4767,78.7801 14.7107,78.0211 C17.9447,77.2611 11.9387,82.8451 11.9387,82.8451 L5.4717,82.8451 Z"
            fill="#F3F4F6"
          />
        </g>
      </g>
    </g>
  </svg>
);
